module.exports = __webpack_public_path__ + "img/vertical_6_7_9005.1991c738.png";